// The E2E auth bypass, shared by every module that has to reason about it.
//
// Multiple guards prevent this from ever activating in a real prod environment:
//   1. VITE_TEST_MODE must be the exact string "true" at build time
//   2. Vite MODE must not be "production"
//   3. The page must NOT be served from a known production hostname
//   4. The bypass identity is a non-real account, not a real employee
//
// Module-level so every path that could drop the session — or issue a request on the
// bypass identity's behalf — consults the same guard. A test-mode session holds no real
// token, so any call behind requireAuth can only ever 401, and the bypass identity exists
// in no environment's database, so any lookup keyed on it can only ever 404. Callers must
// answer such calls locally rather than putting them on the wire (WIPE-1190).
const PROD_HOSTNAMES = [
  'os.weinsureagent.com',
  'd3lfoffhi0o29w.cloudfront.net',
];

export function isTestModeBypass(): boolean {
  return (
    import.meta.env.VITE_TEST_MODE === 'true' &&
    import.meta.env.MODE !== 'production' &&
    !PROD_HOSTNAMES.includes(window.location.hostname)
  );
}

export const TEST_MODE_EMAIL = 'e2e-tests@weinsuregroup.com';

export const TEST_MODE_NAME = 'E2E Test User';
